
import {getBasicsetTotalList, getOrderCarOrderinfo} from "@/api/http";

type parts = {
    basicset_name: string;
    ordersn: string;
    order_crd_code_text: string;
    order_message_text: string;
    create_time: string;
    settlementperson_text: string;
    settlement_time: string;
    settlement_status_text: string;
    order_offer_price: string;
    settlement_notes: string;
    return_price: string | null;
    price: string;
    settlement_type_text: string | null;
};

type paramsType = {
    basicset_id:number,
    type:number,
    time: Array<number>,
    start_date: number,
    end_date: number
}

const columnList: Array<column> = [
    {
        prop: "basicset_name",
        label: "服务类型",
        width: 60,
    },
    {
        prop: "order_crd_code_text",
        label: "车牌号",
        width: 70,
    },
    {
        prop: "order_message_text",
        label: "接车人",
        width: 60,
    },
    {
        prop: "create_time",
        label: "开单时间",
        width: 75,
    },
    {
        prop: "settlementperson_text",
        label: "结算人",
        width: 60,
    },
    {
        prop: "settlement_time",
        label: "结算时间",
        width: 75,
    },
    {
        prop: "settlement_status_text",
        label: "结算状态",
        width: 60,
    },
    {
        prop: "order_offer_price",
        label: "报价金额",
        width: 60,
    },
    {
        prop: "settlement_notes",
        label: "工单备注",
        width: 75,
    },
    {
        prop: "return_price",
        label: "待回款",
        width: 60,
    },
    {
        prop: "price",
        label: "结算金额",
        width: 60,
    },
    {
        prop: "settlement_type_text",
        label: "结算方式",
        width: 60,
    },
];

const offerColumn: Array<column> = [
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    },
];
const projectColumn: Array<column> = [
    {
        prop: "project_name",
        label: "维修项目报价",
        width: 80,
    },
    ...offerColumn,
];
const partsColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件报价",
        width: 80,
    },
    {
        prop: "mountings_id_encoding",
        label: "规格",
        width: 80,
    },
    {
        prop: "supplier_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    }
];
const mountingsCostColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件成本",
        width: 80,
    },
    {
        prop: "collar_num",
        label: "领料",
        width: 80,
    },
    {
        prop: "retreat_num",
        label: "退料",
        width: 80,
    },
    {
        prop: "use_num",
        label: "用量",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "cost",
        label: "成本价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
];
const elseCostColumn: Array<column> = [
    {
        prop: "othercosts_name",
        label: "其他成本",
        width: 80,
    },
    {
        prop: "supplier_id_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "cpayment_text",
        label: "生成应付款",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "othercosts_costprice",
        label: "金额",
        width: 80,
    },
];
const settlementColumn: Array<column> = [
    {
        prop: "pay_name",
        label: "工单结算",
        width: 80,
    },
    {
        prop: "pay_type_name",
        label: "支付方式",
        width: 80,
    },
    {
        prop: "pay_price",
        label: "金额",
        width: 80,
    },
    {
        prop: "pay_ctime",
        label: "时间",
        width: 80,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted
} from "vue";
import {dateformat, getFirstNowLastDay} from "@/api/date" ;
import {Request} from '@/api/request';
import { column } from "@/assets/types/common";
import {useRoute, useRouter} from "vue-router";
export default defineComponent({
    name: "businessSummaryDetail",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['营业详情']);
        
        const headClass = inject("headClass");
        const Router = useRouter();
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<parts>),
            total = ref(0),
            selectList = reactive({
                serveTypeList:[]
            }),
    
            dialogFormVisible = ref(false),
            dialogTable = ref([] as Array<any>),
            orderDetail = ref({} as any),
            
            total_price = ref(0),
            head_office_price = ref(0),
            split_office_price = ref(0),
            loading = ref(false),
            totalData = reactive({} as any),
            params:paramsType = reactive({
                basicset_id:0,
                type:1,
                time: [],
                start_date: 0,
                end_date: 0,
                date_type:2
            });
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getSummaries = (param: any): Array<string> => {
                const { columns, data } = param;
                const sums: any = [];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    if (column.property=='number_sets'){
                        sums[index] = totalData.total_number_sets;
                    }
                    if (column.property=='number_cost'){
                        sums[index] = totalData.total_number_cost;
                    }
                    if (column.property=='number_hours'){
                        sums[index] = totalData.total_number_hours;
                    }
                    if (column.property=='number_parts'){
                        sums[index] = totalData.total_number_parts;
                    }
                    if (column.property=='number_parts_cost'){
                        sums[index] = totalData.total_number_parts_cost;
                    }
                    if (column.property=='number_parts_profit'){
                        sums[index] = totalData.total_number_parts_profit;
                    }
                    if (column.property=='number_parts_profit_rate'){
                        sums[index] = totalData.total_number_parts_profit_rate;
                    }
                    if (column.property=='number_profit'){
                        sums[index] = totalData.total_number_profit;
                    }
                    if (column.property=='number_profit_rate'){
                        sums[index] = totalData.total_number_profit_rate;
                    }
                    if (column.property=='number_turnover'){
                        sums[index] = totalData.total_number_turnover;
                    }
                    
                });
                return sums;
            },
            screenChange = (e: string | Array < any > , key: any): void => {
                getTableData();
            },
            getSummariesDia = (param: any, type: number): Array<string> => {
                const {columns, data} = param;
                const sums: any = [];
                const propArr = [
                    "othercosts_costprice",
                    "price",
                    "output_value",
                    "pay_price",
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        switch (type) {
                            // 维修项目报价合计
                            case 1:
                                if (column.property == "price") {
                                    sums[index] = orderDetail.value.project_sum_quoted_price;
                                } else {
                                    sums[index] = orderDetail.value.project_sum_output_value;
                                }
                                break;
                            // 配件报价合计
                            case 2:
                                if (column.property == "output_value") {
                                    sums[index] = orderDetail.value.mountings_sum_output_value;
                                } else {
                                    sums[index] = orderDetail.value.mountings_sum_quoted_price;
                                }
                        
                                break;
                            // 配件成本合计
                            case 3:
                                sums[index] = orderDetail.value.mountings_cost_price;
                                break;
                            // 其他成本合计
                            case 4:
                                sums[index] = orderDetail.value.else_cost_price;
                                break;
                            // 工单结算合计
                            case 5:
                                sums[index] = orderDetail.value.settlement_pirce;
                                break;
                        }
                        sums[index] = `¥${sums[index]}`;
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            // 点击单据编号触发
            getOrderCarinfo = (item: any) => {
                if (item.order_id<=0){
                    return;
                }
                getOrderCarOrderinfo({order_id: item.order_id}).then((res: any) => {
                    if (res.status == 200) {
                        dialogFormVisible.value = true;
                        let info = res.content.list;
                        if (info) {
                            let arr = [[
                                '单据编号',
                                info.ordersn,
                                '状态',
                                info.orderstatustext,
                                '开单时间',
                                info.create_time_text,
                                '结算时间',
                                info.settlement_time_text,
                            ], [
                                '服务类型',
                                info.basicset_id_name,
                                '接车人',
                                info.meet_vehicle_id_name,
                                '报价金额',
                                info.offer_price,
                                '结算金额',
                                info.settlement_pirce,
                            ], [
                                '车牌号码',
                                info.car_code,
                                '品牌车型',
                                info.series_name,
                                '进厂里程',
                                info.mitplant,
                                '是否返修',
                                info.is_rework_text,
                            ], [
                                '送修人',
                                info.send_for_repair,
                                '手机号码',
                                info.send_for_repair_phone,
                                '会员号',
                                info.user_id,
                                '昵称',
                                info.user_nickname,
                            ], [
                                '保险公司',
                                info.cicompany_id_name,
                                '送修单位',
                                info.units_id_name,
                                '合作方',
                                info.partner_id_name,
                                '工单备注',
                                info.settlement_notes,
                            ]];
                            dialogTable.value = arr;
                            orderDetail.value = res.content.list;
                        }
                    }
                });
            },
            detailClick = ()=>{
            
            },
            getTableData = (): void => {
                //params.start_time = params.time?Math.floor(new Date(params.time[0]).getTime()/1000):0;
                //params.end_time = params.time ?Math.floor((new Date(params.time[1]).getTime()+24*60*60*1000-1)/1000):0;
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/order/workSettlement',
                    data: {...params, page: currentPage.value,pagesize:pageSize.value}
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    console.log(tableData)
                });
                
            }
        onMounted(() => {
            getBasicsetTotalList({basicset_type:2}).then((res:any)=>{
                selectList.serveTypeList = res.content.list;
            });
            params.start_date = Number(useRoute().query.start_time);
            params.end_date = Number(useRoute().query.end_time);
            params.basicset_id = Number(useRoute().query.pay_type);
            getTableData();
        });
        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            handleSizeChange,
            handleCurrentChange,
            total,
            loading,
            getSummaries,
            total_price,
            head_office_price,
            split_office_price,
            params,
            screenChange,
            selectList,
            detailClick,
    
            dialogFormVisible,
            getOrderCarinfo,
            dialogTable,
            orderDetail,
            getSummariesDia,
            projectColumn,
            partsColumn,
            mountingsCostColumn,
            elseCostColumn,
            settlementColumn
        };
    },
});
